export default "__VITE_ASSET__Bvon$EFh__"